<template>
  <b-button variant="white" class="btn" :class="{'btn_active' : active, 'middle' : (made > 0 || push > 0)}" @click="() => {self.$emit('onPress')}">
    <div class="btn_day_text" :class="{'btn_active_text' : active}">
      <template v-if="made==0 && push ==0">{{day}}일</template>
      <template v-if="(made > 0 || push > 0) && (push == 5 || made == 5)">5회</template>
      <template v-if="(made > 0 || push > 0) && (push == 13 || made == 13)">10+3</template>
      <template v-if="(made > 0 || push > 0) && (push == 30 || made == 30)">20+10</template>
    </div>
    <span class="btn_percent_text" v-if="percent > 0" :class="{'btn_active_text' : active}">{{percent}}% 할인</span>
  </b-button>
</template>

<script>
import Utils from "../../config/utils"
const utils = require('util')
export default {
  name: "StateButton",
  data() {
    return {
      ut: utils,
      u: Utils,
      self: this,
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    item: {},
  },
  computed: {
    day: function () { return this.item.day },
    point: function () { return this.item.point },
    percent: function () { return this.item.percent },
    made: function () { return this.item.made },
    push: function () { return this.item.push },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/vars";
.btn{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100%;
  border-style: solid;
  border-width: 1.5px;
  border-color: #e5e4e1;
  border-radius: 5px;
  margin-bottom: 7px;
  margin-left: auto;
  margin-right: auto;
};
.btn.small{
  max-width: 80px;
}
.btn.middle{
  max-width: 100px;
}
//.align-horizontal {justify-content: center}
.btn_active {border-color: $c_457fff }
.btn_day_text {font-size: $fs_22; color: #e5e4e1; font-family: $korean_gd_16_r; }
.btn_point_text {font-size: $fs_20; color: #e5e4e1; font-family: $korean_gd_16_r;}
.btn_percent_text {margin-left: 6px; font-size: $fs_12; color: white; background-color: #e5e4e1; font-family: $korean_gd_16_r; padding: 2px 4px;}
.btn_active_text {color: $c_457fff }
.btn_percent_text.btn_active_text {color: white; background-color: #cf0000;}
</style>



// WEBPACK FOOTER //
// src/components/controls/StateButton.vue